export default __webpack_public_path__ + "static/media/s-pro-mara-logo-banner EU Nor.9a6133dc.png";